import type { ExtraReducerBuilder } from '@ui/features/alpha/types/state';
import { importAlphaSpreadsheet } from '@ui/features/quote-builder/state/endpoints/import-alpha-spreadsheet';

import * as reducers from '../reducers';

export function createImportAlphaSpreadsheetReducer(
  builder: ExtraReducerBuilder,
) {
  builder.addMatcher(importAlphaSpreadsheet.matchFulfilled, (state, action) => {
    reducers.appendImportedLineItems(state, {
      type: 'importAlphaSpreadsheet/matchFulfilled',
      payload: {
        importedLineItems: action.payload,
      },
    });
  });
}
